export interface TimeUnit {
  value: number;
  unit: 'seconds' | 'minutes' | 'hours' | 'days';
}

export const convertMsToTimeUnit = (durationMs: number): TimeUnit => {
  const seconds = Math.floor(durationMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return { value: days, unit: 'days' };
  }
  if (hours > 0) {
    return { value: hours, unit: 'hours' };
  }
  if (minutes > 0) {
    return { value: minutes, unit: 'minutes' };
  }
  return { value: seconds, unit: 'seconds' };
};

export const convertTimeUnitToMs = (value: number, unit: 'seconds' | 'minutes' | 'hours' | 'days'): number => {
  switch (unit) {
    case 'seconds':
      return value * 1000;
    case 'minutes':
      return value * 60 * 1000;
    case 'hours':
      return value * 60 * 60 * 1000;
    case 'days':
      return value * 24 * 60 * 60 * 1000;
    default:
      return value * 60 * 60 * 1000; // Default to hours
  }
};

export const formatDelayTime = (durationMs?: number): string => {
  if (!durationMs) return 'Not configured';

  const { value, unit } = convertMsToTimeUnit(durationMs);
  const pluralUnit = value === 1 ? unit.slice(0, -1) : unit;
  return `${value} ${pluralUnit}`;
};

export const getDelayStateFromDuration = (durationMs: number) => {
  const totalHours = durationMs / 3600000; // Convert ms to hours
  const totalDays = totalHours / 24; // Convert hours to days

  // If >= 1 day, display in days (with decimals)
  const isInDays = totalDays >= 1;

  if (isInDays) {
    // Preserve up to 4 decimal places for days, removing trailing zeros
    const amount = totalDays % 1 === 0 ? Math.floor(totalDays) : Number(Number(totalDays.toFixed(4)).toString());
    return { amount, unit: 'days' };
  } else {
    // Preserve up to 4 decimal places for hours, removing trailing zeros
    const amount = totalHours % 1 === 0 ? Math.floor(totalHours) : Number(Number(totalHours.toFixed(4)).toString());
    return { amount, unit: 'hours' };
  }
};
